module.exports = __webpack_public_path__ + "img/transIcon.792b1ee7.png";